import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "hw-100"
};
import { computed } from '@vue/reactivity';
import { useStore } from '@/store';
import { useRoute } from 'vue-router';
import { RouteConstants } from '@/models/constant';
import { ref } from 'vue';
import MenuItem from '@/layout/components/menu/menu-item.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'app-menu',
  setup(__props) {
    const storeM = useStore();
    const route = useRoute();
    const menuType = ref(1);
    // computed
    const routes = computed(() => {
      console.log('storeM.state.permission.routes-----', storeM.state.permission.routes);
      return storeM.state.permission.routes;
    });
    const activeMenu = computed(() => {
      const {
        path,
        meta
      } = route;
      // return '/workbench/student-performance-evaluation'
      if (meta.parentActive) {
        return meta.parent;
      }
      if (meta.parent && meta.parent.indexOf(RouteConstants.ADMIN_ROOT_DIRECTORY) > -1) {
        menuType.value = 1;
      } else {
        menuType.value = 1;
      }
      return path;
    });
    // 菜单点击选择
    const handleSelect = () => {
      // 忘记密码逻辑
      console.log('忘记密码');
    };
    return (_ctx, _cache) => {
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(routes).length > 0 && menuType.value === 1 ? (_openBlock(), _createBlock(_component_el_menu, {
        key: 0,
        "default-active": _unref(activeMenu),
        mode: "vertical",
        "text-color": "#000000",
        "active-text-color": "#2458AB",
        router: "",
        ellipsis: "",
        class: "sxyx-menu",
        onSelect: handleSelect
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes), route => {
          return _openBlock(), _createBlock(MenuItem, {
            key: route.path,
            route: route
          }, null, 8, ["route"]);
        }), 128))]),
        _: 1
      }, 8, ["default-active"])) : _createCommentVNode("", true)]);
    };
  }
});